<template>
  <div class="profile">
    <!-- Dialog loading -->
    <F2gDialogLoader
      :value="profile.status === 'loading' || auth.status === 'loading'"
    />

    <div class="profile__wrapper pa-4">
      <v-flex xs12>
        <div class="card__header-image">
          <div class="card__body__profile__image">
            <v-img
              v-if="auth.userProfile.ownerPerson"
              class="card__body__profile__image__item"
              :src="auth.userProfile.ownerPerson.logo"
              :contain="true"
            />
            <v-img
              v-else
              :src="require('@/flit2go-web-core/assets/flit2goLogo.svg')"
              class="card__body__profile__image__item"
              :contain="true"
            />
          </div>
        </div>
        <div class="card__body pt-3 pb-5">
          <v-layout wrap>
            <v-flex md4 xs12>
              <v-card
                height="auto"
                :class="{
                  'card__body__profile pa-5 mb-5': true,
                  'mr-5': !isScreenSizeSmall,
                }"
              >
                <v-layout align-center class="mb-3">
                  <F2gIcon class="svg mr-2" value="user" />
                  <span
                    >{{ auth.userProfile.name }}&nbsp;{{
                      auth.userProfile.surnames
                    }}</span
                  >
                </v-layout>
                <v-layout align-center class="mb-3">
                  <F2gIcon class="svg mr-2" value="tribunal-1" />
                  <span v-if="auth.userProfile.ownerPerson">{{
                    auth.userProfile.ownerPerson.name
                  }}</span>
                  <span v-else v-html="$t('common.flit2go')"></span>
                </v-layout>
                <v-layout align-center class="mb-3">
                  <F2gIcon class="svg mr-2" value="rol" />
                  <span
                    v-if="
                      auth.userProfile &&
                      auth.userProfile.authorities &&
                      (auth.userProfile.authorities[0] == 'SUPER_ADMIN' ||
                        auth.userProfile.authorities[0] == 'SUPPORT' ||
                        auth.userProfile.authorities[0] == 'EMPLOYEE' ||
                        auth.userProfile.authorities[0] == 'OWNER_EMPLOYEE') &&
                      auth.userProfile.idEmployee
                    "
                    >{{ auth.userProfile.idEmployee }}</span
                  >
                  <span
                    v-else-if="
                      auth.userProfile &&
                      auth.userProfile.authorities &&
                      (auth.userProfile.authorities[0] == 'SUPER_ADMIN' ||
                        auth.userProfile.authorities[0] == 'SUPPORT' ||
                        auth.userProfile.authorities[0] == 'EMPLOYEE') &&
                      !auth.userProfile.idEmployee
                    "
                    >-</span
                  >
                  <span v-else>{{
                    auth.userProfile && auth.userProfile.authorities
                      ? formatRol(auth.userProfile.authorities[0])
                      : ""
                  }}</span>
                </v-layout>
                <editablePhoneVerification
                  class="mb-3"
                  :phone="auth.userProfile.phoneNumber"
                  @validationCodeSended="(value) => $showMessage.success(value)"
                  @phoneChanged="(value) => $showMessage.success(value)"
                  @error="(value) => $showMessage.error(value)"
                />
                <v-layout align-center class="mb-3">
                  <F2gIcon class="svg mr-2" value="email" />
                  <span>{{ auth.userProfile.username }}</span>
                </v-layout>
                <v-layout
                  align-center
                  class="mb-3"
                  v-if="auth.userProfile.address"
                >
                  <F2gIcon class="svg mr-2" value="ubication" />
                  <div>
                    <span v-if="auth.userProfile.address.direction">{{
                      auth.userProfile.address.direction
                    }}</span>
                    <br v-if="auth.userProfile.address.direction" />
                    <span>{{
                      auth.userProfile.address.directionAdditionalInfo
                    }}</span>
                    <br
                      v-if="auth.userProfile.address.directionAdditionalInfo"
                    />
                    {{ auth.userProfile.address.postalCode }}
                    {{ auth.userProfile.address.locality }},
                    {{ auth.userProfile.address.city }},
                    {{ auth.userProfile.address.country }}
                  </div>
                </v-layout>
                <div class="mb-3 mr-2 flex-row">
                  <F2gIcon
                    v-if="!edit"
                    value="protected"
                    :stroke="$CONSTANTS.COLOUR.DARK_GRAY_1_F2G"
                    :width="26"
                    :height="26"
                    class="svg mr-2"
                  />
                  <v-layout v-if="!edit" align-center>
                    <div class="flex-col-center">*************</div>
                    <F2gIcon
                      v-if="!edit"
                      class="editIcon ml-3"
                      value="edit"
                      :stroke="colorPrimaryForHover"
                      :strokeWidth="3"
                      :width="!edit ? 20 : 24"
                      :height="!edit ? 20 : 24"
                      @click="edit = true"
                    />
                  </v-layout>
                  <!-- Password fields -->
                  <v-layout v-else column>
                    <v-layout justify-space-between style="align-items: center">
                      <F2gIcon
                        value="protected"
                        :stroke="$CONSTANTS.COLOUR.DARK_GRAY_1_F2G"
                        :width="26"
                        :height="26"
                        class="svg mr-2"
                      />
                      <v-text-field
                        v-model="oldPassword"
                        type="password"
                        required
                        counter="40"
                        maxlength="40"
                        :label="$t('forms.actualPassword')"
                        :error-messages="oldPasswordErrors"
                        @input="$v.oldPassword.$touch()"
                        @blur="$v.oldPassword.$touch()"
                      />
                    </v-layout>

                    <v-layout justify-space-between style="align-items: center">
                      <F2gIcon
                        value="protected"
                        :stroke="$CONSTANTS.COLOUR.DARK_GRAY_1_F2G"
                        :width="26"
                        :height="26"
                        class="svg mr-2"
                      />
                      <v-text-field
                        v-model="newPassword"
                        type="password"
                        required
                        counter="40"
                        maxlength="40"
                        :label="$t('forms.newPassword')"
                        :error-messages="newPasswordErrors"
                        @input="$v.newPassword.$touch()"
                        @blur="$v.newPassword.$touch()"
                      />
                    </v-layout>

                    <v-layout justify-space-between style="align-items: center">
                      <F2gIcon
                        value="protected"
                        :stroke="$CONSTANTS.COLOUR.DARK_GRAY_1_F2G"
                        :width="26"
                        :height="26"
                        class="svg mr-2"
                      />
                      <v-text-field
                        v-model="newPasswordRepeat"
                        type="password"
                        required
                        counter="40"
                        maxlength="40"
                        :label="$t('forms.passwordRepeat')"
                        :error-messages="newPasswordRepeatErrors"
                        @input="$v.newPasswordRepeat.$touch()"
                        @blur="$v.newPasswordRepeat.$touch()"
                      />
                    </v-layout>
                    <v-layout class="mt-2" wrap justify-start>
                      <v-btn
                        class="button-rounded mr-4"
                        color="primary"
                        :disabled="$v.$invalid"
                        @click="changePassword()"
                        >{{ $t("common.confirm") }}</v-btn
                      >
                      <v-btn
                        class="button-rounded"
                        color="error"
                        @click="clear()"
                        >{{ $t("common.cancel") }}</v-btn
                      >
                    </v-layout>
                    <v-layout justify-start>
                      <h4
                        v-html="$t('common.forgotPassword')"
                        class="my-4"
                        :style="{
                          color: colorPrimaryForHover,
                          fontWeight: 500,
                        }"
                        @click="
                          () => {
                            enterEmail = true;
                            showPopUp = true;
                          }
                        "
                      />
                    </v-layout>
                  </v-layout>
                </div>

                <!-- MFA -->
                <mfaActivationField
                  :activeMfa="auth.userProfile.mfa"
                  @validatedMfa="(value) => $showMessage.success(value)"
                  @error="(value) => $showMessage.error(value)"
                />

                <div class="mt-10">
                  <span v-html="$t('downloadAppService')"></span>

                  <!-- Google play -->
                  <div class="flex-row items-center mr-2">
                    <div
                      style="width: 150px; margin-left: -8px; object-fit: cover"
                    >
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://play.google.com/store/apps/details?id=com.flit2go.flit2goservice"
                      >
                        <img
                          class="w-full"
                          alt="Disponible en Google Play"
                          src="@/flit2go-web-core/assets/google-play-badge.png"
                        />
                      </a>
                    </div>
                    <span style="align-self: center">{{
                      $t("androidVersion")
                    }}</span>
                  </div>

                  <!-- IOS (App Store) -->
                  <div class="flex-row items-center">
                    <div class="mr-3" style="width: 132px; object-fit: cover">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://apps.apple.com/es/app/service/id6467632432"
                      >
                        <img
                          class="w-full"
                          src="@/flit2go-web-core/assets/apple-store-badge.svg"
                          alt="Apple Store"
                        />
                      </a>
                    </div>
                    <span style="align-self: center">{{
                      $t("iosVersion")
                    }}</span>
                  </div>
                </div>
              </v-card>
            </v-flex>
            <!-- notifications -->
            <v-flex md8 xs12>
              <v-card class="card__body__profile pa-5 v-full">
                <notifications-panel />
              </v-card>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
    </div>
    <transition name="fade">
      <PopUpRecoverPassword
        v-if="showPopUp"
        :show="showPopUp"
        :email="email"
        :enterEmail="enterEmail"
        @closePopUp="showPopUp = false"
        @sentEmail="sendEmail"
        class="popup-password"
      ></PopUpRecoverPassword>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
  required,
  maxLength,
  minLength,
  sameAs,
} from "vuelidate/lib/validators";
import PopUpRecoverPassword from "@/flit2go-web-core/components/popup-recover-password";
import NotificationsPanel from "@/flit2go-web-core/components/notifications/notifications-panel";
import editablePhoneVerification from "@/flit2go-web-core/components/fields/editablePhoneVerification";
import mfaActivationField from "@/flit2go-web-core/components/fields/mfaActivationField";
export default {
  name: "Profile",
  components: {
    PopUpRecoverPassword,
    NotificationsPanel,
    editablePhoneVerification,
    mfaActivationField,
  },
  validations() {
    return {
      oldPassword: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(40),
      },
      newPassword: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(40),
      },
      newPasswordRepeat: { sameAsPassword: sameAs(() => this.newPassword) },
    };
  },
  data: () => ({
    colorPrimaryForHover: null,
    edit: false,
    enterEmail: false,
    email: "",
    hoverPassword: true,
    newPassword: "",
    newPasswordRepeat: "",
    oldPassword: "",
    showPopUp: false,
  }),
  mounted() {
    this.colorPrimaryForHover = this.ownerColors.ownerPrimaryColor;
  },
  computed: {
    ...mapState(["auth", "profile"]),
    ...mapGetters({
      ownerColors: "auth/getOwnerColors",
    }),
    isScreenSizeSmall() {
      return (
        this.$vuetify.breakpoint.name === "xs" ||
        this.$vuetify.breakpoint.name === "sm"
      );
    },
    oldPasswordErrors() {
      const errors = [];
      if (!this.$v.oldPassword.$dirty) {
        !this.$v.oldPassword.required &&
          errors.push(this.$t("errors.required"));
        !this.$v.oldPassword.minLength &&
          errors.push(this.$t("errors.passwordLength"));
        !this.$v.oldPassword.maxLength &&
          errors.push(this.$t("errors.passwordLength"));
      }
      return errors;
    },
    newPasswordErrors() {
      const errors = [];
      if (!this.$v.newPassword.$dirty) {
        !this.$v.newPassword.required &&
          errors.push(this.$t("errors.required"));
        !this.$v.newPassword.minLength &&
          errors.push(this.$t("errors.passwordLength"));
        !this.$v.newPassword.maxLength &&
          errors.push(this.$t("errors.passwordLength"));
      }
      return errors;
    },
    newPasswordRepeatErrors() {
      const errors = [];
      if (!this.$v.newPasswordRepeat.$dirty) {
        !this.$v.newPasswordRepeat.sameAsPassword &&
          errors.push(this.$t("errors.passwordsNotMatch"));
      }
      return errors;
    },
  },
  methods: {
    sendEmail(email) {
      this.email = email;
      this.$store
        .dispatch("auth/sendEmailToUser", this.auth.userProfile.id)
        .then(() => {
          this.enterEmail = false;
          this.showPopUp = true;
        })
        .catch(() => {
          this.$showMessage.error(this.$t("errors.sendEmail"));
        });
      this.enterEmail = false;
    },
    formatRol(rol) {
      return rol.substring(0, 1) + rol.substring(1, rol.length).toLowerCase();
    },
    clear() {
      this.$v.$reset();
      this.oldPassword = "";
      this.newPassword = "";
      this.newPasswordRepeat = "";
      this.edit = false;
    },
    changePassword() {
      if (!this.$v.$invalid) {
        this.$store
          .dispatch("profile/changePassword", {
            id: this.auth.userProfile.id,
            newPassword: this.newPassword,
            oldPassword: this.oldPassword,
          })
          .then(() => {
            this.$showMessage.success(this.$t("common.correctChangePassword"));
            this.$v.$reset();
            this.oldPassword = "";
            this.newPassword = "";
            this.newPasswordRepeat = "";
            this.edit = false;
          })
          .catch(() => {
            this.$showMessage.error(this.$t("errors.changePassword"));
          });
      } else {
        this.$v.$touch();
        this.$showMessage.error(this.$t("errors.incorrectData"));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.profile {
  position: relative;

  .v-progress-linear {
    position: absolute;
    top: 0;
    left: 0;
    margin: 0;
  }

  .profile__wrapper {
    padding: 0px 60px 0px 60px;
    @media (max-width: 650px) {
      padding: 0px 20px 0px 20px;
    }
  }

  .card {
    z-index: 1;
  }

  .card__header-image {
    height: 150px !important;
    width: 100% !important;
    z-index: 1 !important;
    border-radius: 16px;
    padding: 16px;
    background-image: url("../../flit2go-web-core/assets/profile-background-grey.svg");
    background-size: cover;
    background-position: center;
  }

  .card__body {
    min-height: 150px;
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    z-index: 1;
  }

  .card__body__profile {
    border-radius: 16px;
    height: fit-content;
  }
  .card__body__profile__image {
    border-radius: 16px;
    height: 118px;
    width: 118px;
    z-index: 100;
    background-color: white;
  }

  .card__body__profile__image__item {
    height: 100%;
    width: 100%;
    border-radius: 16px;
    object-fit: cover;
  }

  .card__body__content {
    height: 100%;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
  }

  .editIcon {
    cursor: pointer;
  }
  .icon {
    stroke: grey;
  }
  .svg {
    height: 26px;
    width: 26px;
    stroke-width: 3;
  }
  h3 {
    color: $gray-1-f2g;
  }

  h4 {
    color: grey;
    font-weight: 300;
    text-align: center;
  }

  .popup-password {
    z-index: 20px;
    position: absolute;
  }

  h4:hover {
    text-decoration: underline solid grey;
    cursor: pointer;
  }
}
</style>
